import * as THREE from 'three';
/**
 * Maintains lightweight orbital motion for summoned orbs.  We avoid per-frame
 * physics by computing analytical circular trajectories around a shared centre.
 */
export class SummonedOrbitController {
    constructor() {
        this.orbits = [];
        this.centre = new THREE.Vector3();
    }
    clear() {
        this.orbits = [];
    }
    setCentre(position) {
        this.centre.copy(position);
    }
    configure(layout, options = {}) {
        var _a, _b;
        const layoutAngular = layout.animation.angularVelocity;
        const layoutMagnitude = Math.abs(layoutAngular);
        const baseMagnitude = (_a = options.angularVelocityBase) !== null && _a !== void 0 ? _a : (layoutMagnitude || 0.6);
        const step = (_b = options.angularVelocityStep) !== null && _b !== void 0 ? _b : 0.05;
        const direction = layoutAngular === 0 ? 1 : Math.sign(layoutAngular);
        this.centre.copy(layout.centre);
        this.orbits = layout.placements.map((placement, index) => {
            var _a, _b;
            const fallback = (baseMagnitude + step * index) * direction;
            const angularVelocity = placement.animation.angularVelocity !== undefined
                ? placement.animation.angularVelocity
                : fallback;
            const phase = (_a = placement.animation.baseAngle) !== null && _a !== void 0 ? _a : placement.angle;
            const radius = (_b = placement.radius) !== null && _b !== void 0 ? _b : layout.radius;
            return {
                orbId: placement.id,
                radius,
                angularVelocity,
                phase,
            };
        });
    }
    addOrb(orbId, radius, angularVelocity, phase) {
        const existing = this.orbits.find(o => o.orbId === orbId);
        if (existing) {
            existing.radius = radius;
            existing.angularVelocity = angularVelocity;
            existing.phase = phase;
            return;
        }
        this.orbits.push({ orbId, radius, angularVelocity, phase });
    }
    update(deltaSeconds, resolvePosition, applyPosition) {
        if (this.orbits.length === 0)
            return;
        const tmp = new THREE.Vector3();
        for (const orbit of this.orbits) {
            orbit.phase += orbit.angularVelocity * deltaSeconds;
            const x = Math.cos(orbit.phase) * orbit.radius;
            const z = Math.sin(orbit.phase) * orbit.radius;
            const current = resolvePosition(orbit.orbId);
            if (current)
                tmp.copy(current);
            tmp.copy(this.centre);
            tmp.x += x;
            tmp.z += z;
            tmp.y = this.centre.y;
            applyPosition(orbit.orbId, tmp);
        }
    }
}
export const summonedOrbitController = new SummonedOrbitController();
